<template>
    <Primitive
        :as="as"
        :class="classes"
    >
        <slot />
    </Primitive>
</template>

<script setup lang="ts">
import type { KCardProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'

import { computed } from 'vue'

defineOptions({ name: 'KCard' })

const props = withDefaults(defineProps<KCardProps>(), {
    as: 'div',
    variant: 'plain',
})

defineSlots<{
    default?: () => unknown
}>()

const { block, modifier } = useBem('k-card')

const classes = computed(() => block(
    modifier(props.variant),
    modifier(props.padding ? `padding-${props.padding}` : ''),
    modifier(props.elevation ? `elevation-${props.elevation}` : ''),
))
</script>

<style lang="scss">
@use './k-card.scss';
</style>
